import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    BBBreachRiskSubscriptionBadge,
    bbDangerousStringToDate,
    BBDisableChildren, bbDoesUserHaveAccessToBreachRiskLevelForAnyEntity,
    bbDoesUserHaveAccessToBreachRiskLevelForEntity,
    bbFormattedDateString, bbGetDisplayNameFromAPIFidelity, bbNumDaysBetweenDates, bbShortenString,
    bbTranslateBreachRiskScoreToCategory,
    bbTranslateBreachRiskScoreToColor,
    filterObject,
    mapObject
} from "../../../util/bbHelpers";
import PropTypes from "prop-types";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import BBDataTable from "../tables/BBDataTable";
import {renderCellExpand} from "../tables/DataGridRenderCellExpand";
import {Badge, Col} from "reactstrap";
import {Button, Chip} from "@material-ui/core";
import BRPortfolioAddNewEntityDialog from "./BRPortfolioAddNewEntityDialog";
import {deleteBRPortfolioEntity, deleteSubportfolio, fetchRiskPortfolio} from "../../../actions";
import BRPortfolioAddReportRequestDialog from "./BRPortfolioAddReportRequestDialog";
import BBIconRoundedDashNull from "../../../assets/bbCustomIcons/BBIconRoundedDashNull";
import BBIconCheckCircleYes from "../../../assets/bbCustomIcons/BBIconCheckCircleYes";
import BBIconArchive from "../../../assets/bbCustomIcons/BBIconArchive";
import BBIconLevelUpArrowEscalation from "../../../assets/bbCustomIcons/BBIconLevelUpArrowEscalation";
import BBIconVerifiedUserActiveAccount from "../../../assets/bbCustomIcons/BBIconVerifiedUserActiveAccount";
import BBIconWaitingHourglass from "../../../assets/bbCustomIcons/BBIconWaitingHourglass";
import BRFidelityBadge from "./BRFidelityBadge";
import {HashLink as Link} from "react-router-hash-link";
import BBIconAttestation from "../../../assets/bbCustomIcons/BBIconAttestation";
import BBIconTechData from "../../../assets/bbCustomIcons/BBIconTechData";
import BBIconGraphChart from "../../../assets/bbCustomIcons/BBIconGraphChart";
import {CircularProgress} from "@mui/material";
import BBIconEmptyBox from "../../../assets/bbCustomIcons/BBIconEmptyBox";
import BBExternalLink from "../accents/BBExternalLink";
import BBIconAddNetwork from "../../../assets/bbCustomIcons/BBIconAddNetwork";
import TileBreachRiskPortfolioNumEntitiesSimple from "../metrics/TileBreachRiskPortfolioNumEntitiesSimple";
import BRPortfolioAddNewSubportfolioDialog from "./BRPortfolioAddNewSubportfolioDialog";
import BBIconTrash from "../../../assets/bbCustomIcons/BBIconTrash";
import BRPortfolioDeleteSubportfolioDialog from "./BRPortfolioDeleteSubportfolioDialog";
import BRPortfolioUpdateSubportfolioDialog from "./BRPortfolioUpdateSubportfolioDialog";

const TableContainer = ({
                            showInsightsDetails = false,
                            showManagementOptions = false,
                            tableTitleText = "Portfolio Group Management",
                            tableTipText = null,
                            tableDescriptionText = null

                        }) => {

    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {portfolios, loadingPortfolios, loadingPortfoliosError, selfEntityId, loadingDeleteBRPortfolioEntity,
        loadingDeleteBRPortfolioEntityError, loadingAddBRPortfolioReportRequest, loadingAddBRPortfolioReportRequestError, loadingAddBRPortfolioEntity, loadingAddBRPortfolioEntityError} = useSelector(({breachrisk}) => breachrisk);
    const {authUser} = useSelector(({auth}) => auth);


    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const customer = customers ? customers[customerIdToUse] : null;
    // const myEntity = portfolios ? portfolios[customerIdToUse] ? portfolios[customerIdToUse].entities ? selfEntityId ? portfolios[customerIdToUse].entities[selfEntityId] : null : null : null : null;

    // console.log("myEntity data", myEntity);

    const dispatch = useDispatch();

    // const entities = portfolios && portfolios[customerIdToUse] ? filterObject(portfolios[customerIdToUse].entities, (_, entity) => entity.id !== selfEntityId) : null;
    const subportfolios = portfolios && portfolios[customerIdToUse] && portfolios[customerIdToUse].portfolios ? portfolios[customerIdToUse].portfolios : null;

    const totalNumSubportfolios = subportfolios ? Object.keys(subportfolios).length : null;

    // if(portfolios && customerIdToUse && portfolios[customerIdToUse]) {
    //     console.log("This portfolio contents:", portfolios[customerIdToUse])
    // }

    // const currentShares =
    //     portfolios
    //     && customerIdToUse
    //     && portfolios[customerIdToUse]
    //         ? portfolios[customerIdToUse].shares
    //         : null;

    // console.log("loadingPortfolios",loadingPortfolios[customerIdToUse], "loadingDeleteBRPortoflkioEntity", loadingDeleteBRPortfolioEntity[customerIdToUse], "loadingAddBRPortfolioEntity", loadingAddBRPortfolioReportRequest[customerIdToUse])

    /**************************/
    /*End Setup State and Dispatch*/
    /**************************/

    const title = <div className={""}>
        {tableTitleText} {tableTipText && <Tooltip title={tableTipText}>
        <InfoSharpIcon style={{fontSize: "smaller"}} className={``}/>
    </Tooltip>}
    </div>;

    const tableDescription = <div className={""}>
        {tableDescriptionText
            ? tableDescriptionText
            : "Add, remove, or edit portfolio groups. Change the member companies of each group."
        }
    </div>;

    // const handleClickDelete = (data) => {
    //     console.log("dispatching handleClickDelete to remove subportfolio with data of", data, customerIdToUse);
    //     dispatch(deleteSubportfolio(
    //         customerIdToUse,
    //         data.subportfolioId
    //     ));
    // }

    const userTableHeadings = [
        { field: 'idShort', headerName: 'ID', hide: true, width: 75, sortable: true, type: 'string', renderCell: (params) => {

                return <Tooltip title={`${params.row.id}`}>
                            <span>
                                {params.value}
                            </span>
                </Tooltip>}},
        { field: 'customerId', headerName: 'CID', hide: true, width: 75, sortable: true, type: 'string', renderCell: (params) => {

                return <Tooltip title={`${params.row.id}`}>
                            <span>
                                {params.value}
                            </span>
                </Tooltip>}},
        { field: 'name', headerName: 'Group Name', hide: false, sortable: true, type: 'string', flex : 1.2, renderCell: (params) =>
                renderCellExpand(params, (<Tooltip title={``}>
                          <span>
                                {params.value}
                          </span>
                    </Tooltip>
                ))},
        { field: 'description', headerName: 'Description', hide: false, sortable: true, type: 'string', flex : 1.5, renderCell: (params) =>
                renderCellExpand(params, (<Tooltip title={``}>
                          <span>
                                {params.value}
                          </span>
                    </Tooltip>
                ))},
        { field: 'memberEntities', headerName: 'Size', hide: false, sortable: true, type: 'string', width : 70, renderCell: (params) =>
                renderCellExpand(params, (<Tooltip title={`Number of companies in this portfolio group.`}>
                          <span>
                                {params.value && Array.isArray(params.value)
                                    ? <span>
                                      {params.value.length}
                                  </span>
                                    : "N/A"}
                          </span>
                    </Tooltip>

                ))},
        { field: 'createdDate', headerName: 'Created', hide: false, sortable: true, type: 'string', width : 120, renderCell: (params) =>
                renderCellExpand(params, (<Tooltip title={`Date the subportfolio was created.`}>
                          <span>
                                {params.value
                                    ? <span>
                                      {bbFormattedDateString(params.value, "short")}
                                  </span>
                                    : "N/A"}
                          </span>
                    </Tooltip>

                ))},



        { field: 'isActive', headerName: 'Active',
            renderHeader: (params) => <Tooltip title={"Active"}>
                <span>Active</span>
            </Tooltip>, hide: true, sortable: true, type: 'string', width: 60, renderCell: (params) =>
                renderCellExpand(params, (<>
                        {params.value
                            ? <Tooltip title={`Portfolio group is active and can be used to organize the companies in your portfolio.`}>
                                  <span>
                                    <BBIconCheckCircleYes className={'text-bb-risk-low'}/>
                                  </span>
                            </Tooltip>
                            : <Tooltip title={`Portfolio group is not active.`}>
                                  <span>
                                    <BBIconRoundedDashNull/>
                                  </span>
                            </Tooltip>
                        }
                    </>

                ))},
        { field: 'actions', headerName: 'Actions',
            renderHeader: (params) => <></>, disableExport: true,
            hide: !showManagementOptions, width : 170, sortable: false, type: 'string',
            renderCell: (params) => {

                return <>
                    <div style={{marginRight:2}}>
                        <BRPortfolioUpdateSubportfolioDialog targetEntityId={selfEntityId} targetSubportfolio={params.row.subportfolioObject}/>
                    </div>
                    <div style={{marginRight:2}}>
                        <BRPortfolioDeleteSubportfolioDialog targetEntityId={selfEntityId} targetSubportfolio={params.row.subportfolioObject}/>
                    </div>


                </>
            }

        },
    ];

    //peel the state data into a form the dataTable can read
    const tableData = subportfolios ? mapObject(subportfolios, (key, subportfolio) => {

        console.log("BRPSubportfoliosManagementTable opening the subportfolio data: ", "subportfolios", subportfolios, "key", key, "subportfolio", subportfolio, "subportfolio.entities", subportfolio.entities, "is array?", Array.isArray(subportfolios.entities) );

        return (
            {
                customerId: customer.CustomerId,
                id: key,
                idShort: key.slice(0, 6),
                name: subportfolio.name,
                description: subportfolio.description,
                createdDate: subportfolio.created_datetime,
                isActive: subportfolio.is_active,
                memberEntities: subportfolio.entities,
                subportfolioObject:subportfolio
            }
        )
    }) : null;

    // console.log("tabledata for the portfolios table", tableData, "which is derived from", entities, "and currentShares", currentShares);
    const tableDataAsArray = () => {
        // console.log("Creating humansTableData as array from humanTableData ", tableData);
        let arr=[];
        for (let ob in tableData) {
            // console.log("ob is ", tableData[ob])
            arr.push(tableData[ob]);
        }
        // console.log("resulting array ", arr);
        return arr;
    }

    const tableHeaderWidgets = <>{ showManagementOptions
        ? <div className={"row pt-1 px-3"}>

            {/*<div className={"col-6"}>*/}
                <BBDisableChildren
                    isDisabled={true} //this is somehow inversed logic and true means false //TODO: CORRECT THE LOGIC OF THE isDisabled in BBDisableChildren
                    // moduleRequired = {"insider"}
                    isCompact
                    isButtonSized
                    blurLevel={2}
                >
                    {/*<div className={"col-12 align-self-center"} id={"tourAddSubportfolioGroup"}>*/}
                        <BRPortfolioAddNewSubportfolioDialog targetEntityId={selfEntityId}/>
                    {/*</div>*/}
                </BBDisableChildren>
            {/*</div>*/}
        </div>
        : null
}</>


    return (
        <div >
            {((subportfolios || totalNumSubportfolios === 0)
                // && myEntity
                // && myEntity.settings
                && customerIdToUse
                && !loadingPortfoliosError[customerIdToUse]
                && !loadingPortfolios[customerIdToUse]
            ) ?
                <BBDataTable
                    id={"tourPortfolioSubportfoliosManagementTable"}
                    portfolioTrial
                    subscriptionNameOrId={"BRP"}
                    elementDisplayNameForConsoleLogs={"BRPPortfolioEntitiesTable"}
                    // isActiveSubscriptionRequiredToUse = {false}
                    columns={userTableHeadings}
                    rows={tableDataAsArray()}
                    totalRows={totalNumSubportfolios}
                    progressValue={subportfolios > 0 ? Object.keys(subportfolios).length / totalNumSubportfolios * 100 : 100}
                    // bufferValue={willBeDoneLocalPagewiseLoadingWhenTargetsIs ? willBeDoneLocalPagewiseLoadingWhenTargetsIs / totalNumTargets * 100 : 0}
                    title={title}
                    description={tableDescription}
                    enableExport
                    loading={false}
                    // requiresModule={"monitor"}
                    customer={customer}
                    topRightElement= {tableHeaderWidgets}
                    defaultSortModel = {

                        showManagementOptions
                            ?[
                                {
                                    field: 'name',
                                    sort: 'asc',
                                },

                            ]
                            : [
                                // {
                                //     field: 'lastScore',
                                //     sort: 'asc',
                                // },
                                // {
                                //     field: 'confidenceCategory',
                                //     sort: 'asc',
                                // }
                                // {
                                //     field: 'lastConfidenceHigh',
                                //     sort: 'asc',
                                // },
                                // {
                                //     field: 'lastConfidenceLow',
                                //     sort: 'desc',
                                // },

                            ]
                    }
                    rowsPerPageOptions = {[10, 25, 50, 100]}
                    defaultPageSize = {25}
                />
                :
                <BBDataTable
                    columns={userTableHeadings}
                    topRightElement= {tableHeaderWidgets}
                    rows={[]}
                    title={title}
                    description={tableDescription}
                    loading = {true}
                    progressValue={0}
                    bufferValue={0}
                    rowsPerPageOptions = {[10, 25, 50, 100]}
                    defaultPageSize = {25}
                    portfolioTrial
                    subscriptionNameOrId={"BRP"}
                />
            }
        </div>
    );



}
TableContainer.propTypes = {
    customerId: PropTypes.string,
};

export default TableContainer